export default [
  {
    title: 'Reportes',
    route: 'reports',
    icon: 'BarChart2Icon',
    resource: 'all',
    action: 'read',
  },
]
